/** 轉倉日欄位說明（Create／List tip）。 */
export const STOCK_TRANSFER_DATE_TIP = '此為實際轉倉日';
